import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SpinnerInterceptor } from './http-interceptor';

export const interceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: SpinnerInterceptor,
    multi: true
  }
];
